export namespace EcuActions {
    export class SetAllEcus {
      static readonly type = '[Ecus] SetAllEcus';
      constructor() {}
    }

    export class SetAllEcusWithSoftwareVersions {
      static readonly type = '[Ecus] SetAllEcusWithSoftwareVersions';
      constructor() {}
    }
  }
  